// extracted by mini-css-extract-plugin
module.exports = {"container":"WarningIcon_container__ColkV"};